module.exports = __webpack_public_path__ + "static/media/gif_carrosel.b6f425a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/gifHome/gif_carrosel.gif
// module id = 202
// module chunks = 0